export default __webpack_public_path__ + "static/media/top-guild-bg.bcccc217.png";